export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen w-full flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/80 via-background-50 to-background-100/40"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100 text-accent-700 rounded-full text-xs font-label mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              实时更新 · 黑料不打烊
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight mb-4">
              黑料
              <span className="block text-primary-600 text-2xl md:text-4xl lg:text-5xl mt-2">
                每日吃瓜爆料第一站
              </span>
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading font-semibold mb-6">
              娱乐圈内幕真相，这里一网打尽
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-8">
              黑料是国内领先的娱乐圈内幕资讯平台，每日更新数百条独家爆料视频与深度解析。
              从明星塌房到综艺翻车，从品牌解约到剧组内幕，我们以最快速度追踪娱乐圈真相。
              无论你是资深吃瓜群众还是偶尔路过的八卦爱好者，在黑料社区你都能找到最新鲜、
              最劲爆的娱乐资讯。黑料不打烊，天天有瓜吃。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">日活吃瓜用户</div>
              </div>
              <div className="w-px h-10 bg-background-200 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">300+</div>
                <div className="text-xs text-foreground-500 mt-1">每日独家爆料</div>
              </div>
              <div className="w-px h-10 bg-background-200 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">7×24h</div>
                <div className="text-xs text-foreground-500 mt-1">全年无休更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-label font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer text-center"
              >
                <i className="ri-fire-line mr-2"></i>查看热榜
              </a>
              <a
                href="#app"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 bg-background-100 text-foreground-800 rounded-full text-sm font-label font-semibold hover:bg-background-200 transition-all duration-200 cursor-pointer text-center"
              >
                <i className="ri-download-line mr-2"></i>下载黑料App
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[560px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-100/60 via-accent-100/40 to-secondary-100/30 rounded-3xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden bg-background-100/80 backdrop-blur-sm">
                <img
                  src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20scene%20with%20mysterious%20atmosphere%2C%20warm%20golden%20spotlight%20piercing%20through%20darkness%2C%20entertainment%20industry%20insider%20aesthetic%2C%20silhouette%20of%20person%20holding%20smartphone%20with%20glowing%20screen%2C%20rich%20amber%20and%20deep%20crimson%20tones%2C%20editorial%20photography%2C%20mysterious%20whistleblower%20theme%2C%20dramatic%20light%20and%20shadow%20contrast&width=1120&height=800&seq=hero-main&orientation=portrait"
                  alt="黑料每日吃瓜爆料 - 娱乐圈内幕追踪"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                  <div className="flex items-center gap-3 text-background-50">
                    <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500">
                      <i className="ri-flashlight-line text-lg"></i>
                    </span>
                    <div>
                      <div className="text-xs text-background-50/70">今日最新</div>
                      <div className="text-sm font-semibold">娱乐圈惊天内幕持续曝光中</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}